import { useGameStore } from '../store/gameSlice';
import { isKnownInterface } from '../components/DOMElements/interfaces.config';
import { logger } from './LoggerService';

/**
 * Centralized interface open/close logic. Lives outside the store so the
 * coupling between `activeInterface` and `isPaused` is explicit and easy
 * to override (e.g. a future overlay that should NOT pause the game can
 * call `setActiveInterface` directly and skip these helpers).
 *
 * Use these helpers as the default entry points: openInterface(id) opens
 * the interface AND pauses; closeInterface() closes AND resumes. They
 * also validate the id against the registry — unknown ids still open
 * (so UnknownInterfaceScreen can render and provide an exit) but emit a
 * warning so the bad config gets noticed.
 */
export function openInterface(id: string): void {
  const { setActiveInterface, setIsPaused } = useGameStore.getState();

  if (!isKnownInterface(id)) {
    logger.warn(
      `[openInterface] no interface registered for id "${id}". ` +
        'Rendering UnknownInterfaceScreen fallback.',
    );
  }

  setActiveInterface(id);
  setIsPaused(true);
}

export function closeInterface(): void {
  const { setActiveInterface, setIsPaused } = useGameStore.getState();
  setActiveInterface(null);
  setIsPaused(false);
}
